<template>
  <section class="star-login">
    <!-- 返回按钮 -->
    <a v-if="isShowBack" class="back" @click="back">
      <img
        src="https://lf26-static.bytednsdoc.com/obj/eden-cn/lmgoeh7bfupevhpe/login-production/back.png"
        alt="<"
      />
      <span>返回</span>
    </a>
    <img
      class="login-bg"
      src="https://lf3-static.bytednsdoc.com/obj/eden-cn/lmgoeh7bfupevhpe/login-production/login-v2.png"
      alt="login-bg"
    />
    <section class="login-container" :class="currentClass">
      <!-- 展示手机登录和邮箱登录切换的 tab -->
      <section class="login-tab">
        <template v-for="item in tabConfig.list">
          <p
            v-if="item"
            :key="item.value"
            class="tab-item"
            :class="[{ active: item.value === tabConfig.choose.value }]"
            @click="switchClick(item)"
          >
            {{ item.key }}
          </p>
        </template>
      </section>
      <section v-if="isShowtips" class="login-tips">
        {{ loginTips }}
      </section>
      <a
        v-if="isMcn && currentPanel === PanelType.login"
        href="/pages/help-center/mcn/article/detail/109107"
        target="_blank"
        class="mcn-tips"
      >
        还没有注册？点这里看看
      </a>
      <section id="login-sdk" class="login-sdk"></section>
    </section>
  </section>
</template>

<script>
// sdk 文档 https://web-bnpm.byted.org/package/@byted/account-center-sdk
import AccountSdk from '@byted/account-center-sdk';
import { merge } from 'lodash-es';
import { UserRole } from './config';
import { ACTIONS, PanelType, SwitchType } from './enums';
import {
  getConfig,
  getTabs,
  // getSubmitStatus,
  getMessageContent,
} from './utils';

export default {
  name: 'LoginSdk',
  data() {
    return {
      SwitchType,
      useConfig: {},
      loginInstance: null,
      // 是否发送过验证码
      hasSend: false,
      // 有一种特殊情况，如果是处于邮箱注册切换为手机登录，如果特殊处理
      isEmailRegister: false,
      PanelType,
      preMessage: '',
    };
  },
  computed: {
    /** 切换 tab 配置 */
    tabConfig() {
      return getTabs(this.role, this.currentSwitch, this.currentPanel);
    },
    /** 当前 sdk 登录类型 */
    currentSwitch() {
      return this.useConfig.switchConfig?.defaultSwitch ?? SwitchType.mobile;
    },
    /** 当前 sdk 登录控制形态 */
    currentPanel() {
      return this.useConfig.switchConfig?.defaultPanel ?? PanelType.login;
    },
    /** 是否展示登录提示 */
    isShowtips() {
      return this.currentPanel === PanelType.login;
    },
    loginTips() {
      if (
        this.currentPanel === PanelType.login &&
        this.currentSwitch === SwitchType.mobile &&
        this.role === 1
      ) {
        return '手机首次登录即自动注册';
      }
      return '';
    },
    isMcn() {
      return this.role === 3;
    },
    extendParams() {
      return {
        userRole: this.role,
        switchType: this.currentSwitch,
        panelType: this.currentPanel,
      };
    },
    currentClass() {
      return `${this.currentSwitch}-switch ${this.currentPanel}-panel role-${this.role}`;
    },
    isShowBack() {
      return this.currentPanel === PanelType.forgetPwd;
    },
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    autoJump: {
      type: Boolean,
      default: true,
    },
    role: {
      type: Number,
      default: 1,
      validator: (value) => {
        const result =
          UserRole.findIndex((item) => item.value === value) !== -1;
        if (!result) {
          console.error(`当前角色 role 为 ${value}，角色目前只支持`, UserRole);
        }
        return result;
      },
    },
    sentry: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    role() {
      this.init();
    },
    config: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init(chaneConfig = null, isReset = true) {
      // 初始化需要先重置状态
      if (this.loginInstance && isReset) {
        this.resetSdk();
      }
      const viewConfig = {
        sentry: this.sentry,
        // 切换状态
        switchCallback: ({ nameType, name }) => {
          if (nameType === 'panel') {
            this.$emit('panel', name);
            this.init({
              switchConfig: {
                defaultSwitch: this.currentSwitch,
                defaultPanel: name,
              },
            });
          }
        },
        // 操作成功后的跳转
        beforeSkip: (url, result) => {
          if (this.currentPanel === PanelType.forgetPwd) {
            // 当前是忘记密码页面成功，那么切到登录页面
            this.$emit('forget-success', {
              url,
              role: this.role,
              result,
              ...this.extendParams,
            });
            this.init({
              switchConfig: {
                defaultSwitch: this.currentSwitch,
                defaultPanel: PanelType.login,
              },
            });
            return;
          }
          if (this.currentPanel === PanelType.register) {
            // 当前是注册逻辑
            this.$emit('register-success', {
              url,
              role: this.role,
              result,
              ...this.extendParams,
            });
            return;
          }
          this.$emit('login-success', {
            url,
            role: this.role,
            result,
            ...this.extendParams,
          });
          if (this.autoJump) {
            location.href = url;
          }
        },
        sendCodeRender: (state) => {
          const { text, codeDisabled } = state;
          if (codeDisabled) {
            this.hasSend = true;
          }
          return /\d/.test(text)
            ? state.text
            : this.hasSend
            ? '重新发送'
            : '获取验证码';
        },
      };
      const mergeConfig = merge({}, this.config, viewConfig, chaneConfig);
      const config = getConfig(mergeConfig, this.role);
      this.loginInstance = new AccountSdk(config);
      this.loginInstance.render();
      // 绑定事件处理
      this.loginInstance.$subscribe((data) => {
        // console.log('subscribe', data, this.loginInstance);
        const { type, nextState } = data;
        switch (type) {
          case ACTIONS.FETCH_CODE_SUCCESS:
            // 验证码发送成功
            this.$emit('code-success');
            break;
        }
        // 判断当前的按钮是否可以点击提交，form 表单校验通过才高亮按钮
        // const submitStatus = getSubmitStatus(
        //   nextState.form,
        //   this.currentSwitch,
        //   this.currentPanel
        // );
        nextState.message.content = getMessageContent(
          nextState.message.content ?? ''
        );
        this.checkedError(nextState.message.content);
        // 因为不可控因素，暂时不修改按钮状态
        // nextState.disabled = !submitStatus;
      });
      // 默认触发一次校验
      this.loginInstance.$dispatch(['form', 'mobile', 'value'], '');
      this.useConfig = config;
      // 触发埋点上报事件
      this.$emit('track', {
        type: 'init',
        params: {
          ...this.extendParams,
        },
      });
      this.initEvent();
    },
    switchClick(item) {
      const currentSwitch = item.include?.[0] ?? SwitchType.mobile;
      let panel = item.include?.[1] ?? PanelType.login;
      // 如果当前处于手机注册，那么先设置为手机登录，todo 保留下次切换邮箱为注册
      if (currentSwitch === SwitchType.mobile && panel === PanelType.register) {
        panel = PanelType.login;
        this.isEmailRegister = true;
      } else {
        this.isEmailRegister = false;
      }
      this.init({
        switchConfig: {
          defaultSwitch: currentSwitch,
          defaultPanel: panel,
        },
      });
    },
    back() {
      // 忘记密码的返回
      this.init({
        switchConfig: {
          defaultSwitch: SwitchType.email,
          defaultPanel: PanelType.login,
        },
      });
    },
    resetSdk() {
      this.loginInstance.destroy();
      this.hasSend = false;
    },
    initEvent() {
      const targets = document.querySelectorAll('.login-type span img');
      const types = ['douyin', 'ixigua', 'toutiao', 'huoshan'];
      targets.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          const key =
            e.target?.parentNode?.className?.replace('icon', '').trim() ?? '';
          if (types.includes(key)) {
            this.$emit('track', {
              type: 'oauth',
              params: {
                state: key,
                ...this.extendParams,
              },
            });
          }
        });
      });
    },
    checkedError(msg) {
      if (String(msg).trim().length === 0) return;
      if (msg === this.preMessage) return;
      this.preMessage = msg;
      this.$emit('track', {
        type: 'error',
        params: {
          message: msg,
          ...this.extendParams,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.star-login {
  position: relative;
  display: flex;
  align-items: center;
  width: 850px;
  height: 530px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: hidden;
  font-family: PingFang SC Arial, sans-serif;

  .login-bg {
    width: 468px;
  }

  .login-container {
    position: relative;
    width: 382px;
  }

  .back {
    position: absolute;
    top: 21px;
    right: 315px;
    color: #999;
    font-size: 14px;
    cursor: pointer;

    img {
      width: 12px;
    }

    &:hover {
      transition: opacity 0.3s ease-out;
      opacity: 0.7;
    }
  }

  .login-tab {
    display: flex;
    font-size: 16px;
    line-height: 24px;
    color: #666;
    padding: 0 50px;

    .tab-item {
      margin: 0 38px 0 0;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #000;
        transition: 0.2s ease-in-out;
      }

      &.active {
        font-weight: bold;
        color: #000;
      }
    }
  }

  .mcn-tips {
    position: absolute;
    font-size: 12px;
    line-height: 20px;
    color: #999;
    bottom: 90px;
    left: 50px;
    z-index: 100;
    font-weight: normal;
  }

  .login-tips {
    padding: 10px 45px 0 50px;
    font-size: 12px;
    line-height: 20px;
    height: 20px;
    color: #999;
  }

  .login-sdk {
    .account-center-sdk-form {
      .account-center-input-row:first-child {
        margin-top: 0;
      }
    }

    .account-center-sdk-container {
      width: 100%;
      box-shadow: none;
      padding: 0 50px !important;
    }

    .account-center-code-captcha {
      color: #38a1ff;
    }

    .account-center-input-agreement {
      margin-top: 30px;
      font-size: 12px;
      color: #999;
      line-height: 20px;

      a {
        color: #38a1ff;

        &:hover {
          transition: opacity 0.3s ease-in-out;
          opacity: 0.7;
        }
      }
    }

    .switch-type-panel {
      display: flex;
      margin-top: 10px;
      min-height: 25px;
      justify-content: space-between;

      .account-center-switch-button.switch-panel {
        font-size: 14px;
        line-height: 20px;
        color: #333;

        &:hover {
          transition: color 0.3s ease-in-out;
          color: #38a1ff;
        }
      }
    }

    .account-center-oauth-list {
      margin-top: 50px;
      display: flex;
      align-items: center;

      label {
        font-size: 12px;
        line-height: 32px;
        color: #666;
        margin-top: 12px;
      }

      .login-type {
        display: flex;
        align-items: center;

        .ixigua img {
          width: auto;
          height: 32px;
        }

        .toutiao img {
          width: 28px;
          height: auto;
        }

        .icon {
          margin-left: 20px;
          margin-right: 0;
        }
      }
    }

    .account-center-message {
      margin: 0;
    }

    .email.register {
      .account-center-oauth-list {
        margin-top: 10px;
      }
    }

    .account-center-sdk-container button {
      font-size: 16px;
    }

    .account-center-sdk-container button.disabled {
      cursor: initial;
    }
  }

  // 单独针对不同场景样式优化
  .login-panel {
    .login-tab {
      margin-top: 30px;
    }
  }

  .email-switch.register-panel {
    .login-tab {
      margin-top: 15px;
    }

    .login-sdk {
      .account-center-input-agreement {
        margin-top: 4px;
      }
    }
  }

  .email-switch.forgetPwd-panel {
    .login-tab {
      margin-top: 20px;
    }

    .login-sdk {
      .account-center-input-agreement {
        margin-top: 10px;
      }
    }

    .login-tab .tab-item.active {
      font-weight: normal;
    }
  }

  .role-3 {
    .login-sdk .switch-type-panel .account-center-switch-button.switch-panel {
      margin-left: auto;
    }

    .mcn-tips {
      bottom: 95px;
    }
  }
}
</style>
